import React, { useMemo, useState } from "react";

import NotificationBroadcastPanel from "../components/notifications/NotificationBroadcastPanel";
import NotificationInbox from "../components/notifications/NotificationInbox";
import InvestorPageHeader from "../components/investor/InvestorPageHeader";
import { useAuth } from "../store/AuthContext";
import { hasAdminModuleAccess } from "../utils/adminPermissions";

const TAB_INBOX = "inbox";
const TAB_BROADCAST = "broadcast";

export default function NotificationsPage() {
  const { user } = useAuth();
  const role = String(user?.role || "").toUpperCase();
  const isAdminStaff = ["ADMIN", "SUPER_ADMIN", "ACCOUNTANT", "MARKETING"].includes(role);
  const canBroadcast = hasAdminModuleAccess(user, "CONTROL");

  const [adminTab, setAdminTab] = useState(TAB_INBOX);

  const subtitle = useMemo(() => {
    if (canBroadcast) {
      return "Your inbox plus tools to send platform-wide notices to investors.";
    }
    if (isAdminStaff) {
      return "Alerts and updates for your staff account.";
    }
    return "Alerts and updates for your account.";
  }, [canBroadcast, isAdminStaff]);

  return (
    <div className="page investor-premium investor-panel inv-notifications-page">
      <InvestorPageHeader icon="notifications" title="Notifications" subtitle={subtitle} />

      {canBroadcast ? (
        <div className="inv-notifications-tabs" role="tablist" aria-label="Notifications sections">
          <button
            type="button"
            role="tab"
            aria-selected={adminTab === TAB_INBOX}
            className={adminTab === TAB_INBOX ? "inv-notifications-tab inv-notifications-tab--active" : "inv-notifications-tab"}
            onClick={() => setAdminTab(TAB_INBOX)}
          >
            My inbox
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={adminTab === TAB_BROADCAST}
            className={adminTab === TAB_BROADCAST ? "inv-notifications-tab inv-notifications-tab--active" : "inv-notifications-tab"}
            onClick={() => setAdminTab(TAB_BROADCAST)}
          >
            Send &amp; history
          </button>
        </div>
      ) : null}

      {canBroadcast && adminTab === TAB_BROADCAST ? (
        <NotificationBroadcastPanel />
      ) : (
        <NotificationInbox />
      )}
    </div>
  );
}
